import Header from "./Header";
import React from "react";

import {Outlet, useLocation} from 'react-router-dom';
const Layout=()=>{
    const location=useLocation();

    if(location.pathname.includes('/panel/letter')){
        return  <Outlet />
    }
    return (<>

        <div className=" ">
            <Header/>
            <div className="w-full py-5 bg-gray-100 layout-height">
                <Outlet />
            </div>

        </div>


    </>)

}
export default Layout;